var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal',{attrs:{"to":"app"}},[_c('div',{class:[{ delay: _vm.delayOpen }, 'popover'],style:({ width: `${_vm.width}px`, ..._vm.positionStyle })},[_c('vs-card',{staticClass:"shadow"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }